// 环境测试
export const SAY_HELLO = 'SAY_HELLO'

// 打开LOADING
export const LOADING_OPEN = 'LOADING_OPEN';

// 关闭LOADING
export const LOADING_CLOSE = 'LOADING_CLOSE';

// 打开OVERLAY
export const OVERLAY_OPEN = 'OVERLAY_OPEN';

// 关闭OVERLAY
export const OVERLAY_CLOSE = 'OVERLAY_CLOSE';

// 打开ALERT
export const ALERT_OPEN = 'ALERT_OPEN';

// 关闭ALERT
export const ALERT_CLOSE = 'ALERT_CLOSE';

// 打开CONFIRM
export const CONFIRM_OPEN = 'CONFIRM_OPEN';

// 关闭CONFIRM
export const CONFIRM_CLOSE = 'CONFIRM_CLOSE';

// 服务层切换路由
export const ROUTER_CHANGE = 'ROUTER_CHANGE';

// 生成UI随机数
export const RANDOM_MAKER = 'RANDOM_MAKER';

// 换肤
export const SKINNING = 'SKINNING'

// 播放声音
export const PLAY_SOUND = 'PLAY_SOUND';

// 停止播放声音
export const STOP_SOUND = 'STOP_SOUND'

// 打开拖拽IFRAME
export const OPEN_DRAG_FRAME = 'OPEN_DRAG_FRAME';

// 关闭拖拽IFRAME
export const CLOSE_DRAG_FRAME ='CLOSE_DRAG_FRAME'

// 打开小提示
export const OPEN_TOAST = 'OPEN_TOAST'

// 关闭小提示
export const CLOSE_TOAST = 'CLOSE_TOAST'

// 打开中奖通知
export const START_WINNER_NOTICE = 'START_WINNER_NOTICE'

// 关闭中奖通知
export const STOP_WINNER_NOTICE = 'STOP_WINNER_NOTICE'

// 打开声音通知提示
export const START_SOUND_NOTICE = 'START_SOUND_NOTICE'

// 关闭声音通知提示
export const STOP_SOUND_NOTICE = 'STOP_SOUND_NOTICE'

// 打开余额显示
export const SHOW_BALANCE = 'SHOW_BALANCE'

// 隐藏余额显示
export const HIDE_BALANCE = 'HIDE_BALANCE'

// 显示UI
export const SHOW_UI = 'SHOW_UI'

// 打开关闭动画
export const TOGGLE_DISPLAY_ANIMATION = 'TOGGLE_DISPLAY_ANIMATION'

// 打开手机版导航左右侧导航菜单
export const NAVIGATOR_OPEN = 'NAVIGATOR_OPEN';

// 关闭手机版导航左右侧导航菜单
export const NAVIGATOR_CLOSE = 'NAVIGATOR_CLOSE';

// 打开IFRAME MODAL
export const IFRAME_MODAL_OPEN = 'IFRAME_MODAL_OPEN';

// 关闭IFRAME MODAL
export const IFRAME_MODAL_CLOSE = 'IFRAME_MODAL_CLOSE';

// 关闭IFRAME MODAL
export const TRANSFER_MODAL_OPEN = 'TRANSFER_MODAL_OPEN';

// 关闭IFRAME MODAL
export const TRANSFER_MODAL_CLOSE = 'TRANSFER_MODAL_CLOSE';

// 广告合集
export const ADS_RECOMMEND = 'ADS_RECOMMEND'